import React from "react";
import banner from "../../Assets/banner.jpg";
import { FiArrowRight, FiBookOpen, FiClipboard, FiTarget, FiAward, FiUsers, FiActivity, FiBriefcase } from "react-icons/fi";

const Tuitions = () => {
  // Coaching categories data with expanded descriptions and icons
  const coachingCategories = [
    { 
      title: "CBSE", 
      description: "We offer expert coaching for CBSE students from Classes 6-12, covering all subjects with a focus on conceptual clarity, structured lessons, and board exam strategies.",
      icon: <FiBookOpen size={32} className="text-[#1ba6db]"/>
    },
    { 
      title: "ICSE",  
      description: "Our ICSE coaching strengthens core subjects, emphasizing analytical skills, in-depth understanding, and strategic study techniques.",
      icon: <FiClipboard size={32} className="text-[#1ba6db]"/>
    },
    {  
      title: "Stateboard", 
      description: "We provide structured coaching for State Board students, ensuring effective preparation through revisions and exam-oriented study plans.",
      icon: <FiTarget size={32} className="text-[#1ba6db]"/>
    },
    { 
      title: "NEET", 
      description: "Our NEET coaching provides rigorous training in Biology, Physics, and Chemistry, with mock tests and expert strategies to secure top ranks.",
      icon: <FiAward size={32} className="text-[#1ba6db]" />
    },
    { 
      title: "IIT-JEE", 
      description: "Our IIT-JEE coaching emphasizes problem-solving, time management, and regular assessments to prepare engineering aspirants effectively.",
      icon: <FiUsers size={32} className="text-[#1ba6db]" />
    },
    { 
      title: "Competitive Exams",   
      description: "We train students for bank, railway, and government job exams with strategy-based learning and extensive practice tests.",
      icon: <FiActivity size={32} className="text-[#1ba6db] " />
    }, 
    { 
    title: "TNPSC", 
    description: "Our TNPSC coaching covers updated syllabus materials, previous year question papers, and structured guidance for success.",
    icon: <FiBriefcase size={32} className="text-[#1ba6db]"/>
    },
  ];

  return (
    <div className="bg-gradient-to-b from-gray-100 to-white ">
      {/* Banner Section */}
      <div className="relative h-[60vh] w-full">
        <img
          src={banner}
          alt="Kalamji Academy Banner"
          className="h-full w-full object-cover "
        />
        <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center px-6 bg-black bg-opacity-50">
          <h1 className="text-5xl font-extrabold animate-fadeInUp">Our Coaching Programs</h1>
          <p className="mt-3 text-xl md:text-2xl animate-fadeInUp delay-200">
            Empowering students with knowledge, confidence, and excellence.
          </p>
          <a
            href="/contact"
            className="mt-6 bg-[#1ba6db] text-white font-semibold py-3 px-6 rounded-lg hover:bg-[#178bb5] transition duration-300 ease-in-out transform hover:scale-105"
          >
            Get Started Today
          </a>
        </div>
      </div>
      {/* Coaching Categories Section */}

      <div className="max-w-7xl mx-auto mt-10 px-6">
        <h2 className="text-3xl font-bold text-center text-gray-800 mb-6">Explore Our Coaching Programs</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 ">
          {coachingCategories.map((course, index) => (
            <div 
              key={index} 
              className="p-6 bg-white border-l-4 border-[#1ba6db] shadow-sm rounded-lg transition-transform duration-300 ease-in-out transform hover:scale-105 hover:bg-[#f1faff]"
            >
              <div className="flex items-center gap-4">
                {course.icon}
                <h2 className="text-xl font-semibold text-[#1ba6db]">{course.title}</h2>
              </div>
              <p className="text-gray-700 mt-2">{course.description}</p>
              <a href="#" className="mt-4 flex items-center text-[#1ba6db] font-medium hover:underline">
                Learn More<FiArrowRight size={20} className="ml-2" />
              </a>
            </div>
          ))}
        </div>

      </div>
      {/* Call to Action Section */}
      <div className="bg-[#1ba6db] text-white text-center py-12 mt-12">
        <h2 className="text-3xl font-semibold">Start Your Journey Today</h2>
        <p className="mt-2 text-lg">Join Kalamji Academy and achieve your academic dreams with expert guidance.</p>

        <a 
          href="/contact" 
          className="mt-6 inline-block bg-white text-[#1ba6db] font-semibold py-3 px-6 rounded-lg hover:bg-gray-200 transition duration-300 ease-in-out transform hover:scale-105"
        >
      Enroll Now
        </a>
      </div>
    </div>
  );
};

export default Tuitions;
